import { useEffect, useState } from 'react';
import AntiforgeryService from '../../../services/anti-forgery.service';

function RequestVerificationTokenInput() {
  const [token, setToken] = useState<string>('');

  useEffect(() => {
    AntiforgeryService.getToken().then(setToken);
  }, []);

  return <input type="hidden" name="__RequestVerificationToken" value={token} />;
}

export default RequestVerificationTokenInput;
